import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Wrapper, Body, Description, Head, Options, Controls, PriceBlock, Price, Title, Header, Button } from './styled';

class IntercomTariffCard extends PureComponent {

    static propTypes = {
        tariff: PropTypes.object,
        cityDomain: PropTypes.string,
        horizontally: PropTypes.bool
    };

    state = {
        windowWidth: null
    };

    onClickButtonHandlerForCard = () => {
        window.location =  '#request';
    };

    render() {
        const { tariff, children, horizontally } = this.props;
        const { name, headingColor, price, description = '' } = tariff;

        return (
            <Wrapper horizontally={horizontally}>
                <Head headingColor={headingColor} horizontally={horizontally}>
                    <Header>
                        <Title horizontally={horizontally}>
                            {name}
                        </Title>
                        { horizontally && <Description horizontally={horizontally}> {description} </Description> }
                    </Header>
                </Head>
                <Body horizontally={horizontally}>
                    <Options className='tariff-card-options' horizontally={horizontally}>
                        {children}
                    </Options>
                    <Controls>
                        <PriceBlock>
                            <Price
                                headingColor={headingColor}
                                value={price}
                                valueText='₽/мес'
                                type='price'
                                labelBottom={horizontally}
                                labelLeft={true}
                            />
                        </PriceBlock>
                        <Button
                            text='Подключить'
                            onClick={() => this.onClickButtonHandlerForCard()}
                            className='button-secondary'
                        />
                    </Controls>
                </Body>
            </Wrapper>
        );
    }

    componentDidMount() {
        if (process.browser && window.innerWidth <= 1280) {
            this.setState({ windowWidth: window.innerWidth });
        }
    }
}

export default IntercomTariffCard;
